<template>
  <div>
    <Rules :rules="quiz.rules" :checkFinish="checkFinish" />
    <div class="list-questions" :class="quiz.mode != 'play' ? 'no-play' : ''">
      <div class="wrap-question" v-for="(question,index) in quiz.questions" v-bind:key="index">
        <OnlyContent v-if="question.settings.optionDisplayStyle == 1 && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer" />
        <OnlyImage v-if="question.settings.optionDisplayStyle == 2 && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer"  />
        <ContentAndImage v-if="question.settings.optionDisplayStyle == 3 && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer"  />
        <TypeAnswer v-if="question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer"  />
      </div>
    </div>
    <Result v-if="checkFinish" :quiz="quiz" :correct_result="correct_result" />
  </div>
</template>

<script>
import OnlyContent from './OnlyContent'
import OnlyImage from './OnlyImage'
import ContentAndImage from './ContentAndImage'
import TypeAnswer from './TypeAnswer'
import Result from './Result'
import Rules from './Rules'


export default {  
  name: "Main",
  components: {
    OnlyContent,
    OnlyImage,
    ContentAndImage,
    TypeAnswer,
    Result,
    Rules
  },
  created() {
    console.log('Quiz Data:', this.quiz);
    if (this.quiz && this.quiz.questions) {
      this.quiz.questions.forEach((question, index) => {
        console.log(`Question ${index}:`, question);
        console.log(`Question ${index} settings:`, question.settings);
      });
    }
  },
  computed: {
    quiz: function(){
      return this.$store.getters.quiz
    },
    checkFinish: function(){
      const finish = this.$store.getters.numQuestionFinish
      if (finish == this.$store.getters.quiz.questions.length){
        return true
      }
      return 
    },
    correct_result: function() {
      let num_correct = 0
      const get_answers = this.$store.getters.getAnswer
      get_answers.filter((x) => x.correct == 1 ? num_correct += 1 : '')
      return num_correct
    },
  }
};
</script>

<style lang="scss">
  @import '~@/styles/main.scss';
</style>